import React from "react";

import DashboardPage from "views/portal/dashboard";
import HubsPage from "views/portal/hubs";
import RevenuePage from "views/portal/revenue";
import SeriesPage from "views/portal/series";
import MarketGuide from "components/guide/MarketGuide";
import ApprovalsPage from "views/portal/approvals";
import MarketsPage from "views/portal/markets";
import CreateMarketPage from "views/portal/markets/CreateMarketWizard";
import FromSourcePage from "views/portal/markets/FromSourcePage";
import MarketDetailPage from "views/portal/market-detail";
import SettlementsPage from "views/portal/settlements";
import PayoutsPage from "views/portal/payouts";
import PayoutAccountPage from "views/portal/payout-account";
import ProfilePage from "views/portal/profile";
import UsersPage from "views/portal/users";
import ReportsPage from "views/portal/reports";
import NotificationsPage from "views/portal/notifications";
import MoneyTimelinePage from "views/portal/money-timeline";
import ReconciliationPage from "views/portal/reconciliation";
import PartnersPage from "views/portal/partners";
import PartnerOverviewPage from "views/portal/partner-overview";
import PartnerRevenuePage from "views/portal/partner-revenue";
import PartnerTeamPage from "views/portal/partner-team";
import PartnerReportsPage from "views/portal/partner-reports";
import PartnerPerformancePage from "views/portal/partner-performance";
import PartnerCuratedPage from "views/portal/partner-curated";
import PartnerSitePage from "views/portal/partner-site";

import SignIn from "views/auth/SignIn";
import AcceptInvite from "views/auth/AcceptInvite";
import SetPassword from "views/auth/SetPassword";
import ForgotPassword from "views/auth/ForgotPassword";
import ResetPassword from "views/auth/ResetPassword";

import {
  MdDashboard,
  MdAttachMoney,
  MdViewList,
  MdReceiptLong,
  MdPayments,
  MdAccountBalanceWallet,
  MdPerson,
  MdGroups,
  MdNotifications,
  MdAssessment,
  MdLock,
  MdTimeline,
  MdHub,
  MdRepeat,
  MdMenuBook,
  MdHandshake,
  MdSpaceDashboard,
  MdSavings,
  MdFactCheck,
  MdInsights,
  MdPlaylistAddCheck,
  MdPalette,
} from "react-icons/md";

const routes = [
  { name: "Dashboard", layout: "/portal", path: "dashboard", access: "tenant", icon: <MdDashboard className="h-6 w-6" />, component: <DashboardPage /> },
  { name: "Overview", layout: "/portal", path: "overview", access: "partner", icon: <MdSpaceDashboard className="h-6 w-6" />, component: <PartnerOverviewPage /> },
  { name: "Hubs", layout: "/portal", path: "hubs", access: "tenant", icon: <MdHub className="h-6 w-6" />, component: <HubsPage /> },
  { name: "Revenue", layout: "/portal", path: "revenue", access: "tenant", icon: <MdAttachMoney className="h-6 w-6" />, component: <RevenuePage /> },
  { name: "Markets", layout: "/portal", path: "markets", icon: <MdViewList className="h-6 w-6" />, component: <MarketsPage /> },
  { name: "Recurring Markets", layout: "/portal", path: "market-series", icon: <MdRepeat className="h-6 w-6" />, component: <SeriesPage /> },
  { name: "Approvals", layout: "/portal", path: "approvals", icon: <MdFactCheck className="h-6 w-6" />, component: <ApprovalsPage /> },
  { name: "Market Guide", layout: "/portal", path: "guide", icon: <MdMenuBook className="h-6 w-6" />, component: <MarketGuide portal="partner" /> },
  { name: "Create Market", layout: "/portal", path: "markets/new", hideInSidebar: true, component: <CreateMarketPage /> },
  { name: "From a Source", layout: "/portal", path: "markets/from-source", access: "tenant", hideInSidebar: true, component: <FromSourcePage /> },
  { name: "Market Detail", layout: "/portal", path: "markets/:id", hideInSidebar: true, component: <MarketDetailPage /> },
  { name: "My Revenue", layout: "/portal", path: "my-revenue", access: "partner", icon: <MdSavings className="h-6 w-6" />, component: <PartnerRevenuePage /> },
  { name: "My Reports", layout: "/portal", path: "my-reports", access: "partner", icon: <MdAssessment className="h-6 w-6" />, component: <PartnerReportsPage /> },
  { name: "Performance", layout: "/portal", path: "performance", access: "partner", icon: <MdInsights className="h-6 w-6" />, component: <PartnerPerformancePage /> },
  { name: "My Site", layout: "/portal", path: "my-site", access: "partner", icon: <MdPalette className="h-6 w-6" />, component: <PartnerSitePage /> },
  { name: "Featured Markets", layout: "/portal", path: "curated-markets", access: "partner", icon: <MdPlaylistAddCheck className="h-6 w-6" />, component: <PartnerCuratedPage /> },
  { name: "Partners", layout: "/portal", path: "partners", access: "tenant", icon: <MdHandshake className="h-6 w-6" />, component: <PartnersPage /> },
  { name: "Settlements", layout: "/portal", path: "settlements", access: "tenant", icon: <MdReceiptLong className="h-6 w-6" />, component: <SettlementsPage /> },
  { name: "Money Timeline", layout: "/portal", path: "money-timeline", access: "tenant", icon: <MdTimeline className="h-6 w-6" />, component: <MoneyTimelinePage /> },
  { name: "Reconciliation", layout: "/portal", path: "reconciliation", access: "tenant", icon: <MdTimeline className="h-6 w-6" />, component: <ReconciliationPage /> },
  { name: "Payout History", layout: "/portal", path: "payouts", access: "tenant", icon: <MdPayments className="h-6 w-6" />, component: <PayoutsPage /> },
  { name: "Payout Account", layout: "/portal", path: "payout-account", access: "tenant", icon: <MdAccountBalanceWallet className="h-6 w-6" />, component: <PayoutAccountPage /> },
  { name: "Reports", layout: "/portal", path: "reports", access: "tenant", icon: <MdAssessment className="h-6 w-6" />, component: <ReportsPage /> },
  { name: "Notifications", layout: "/portal", path: "notifications", access: "tenant", icon: <MdNotifications className="h-6 w-6" />, component: <NotificationsPage /> },
  { name: "Users", layout: "/portal", path: "users", access: "tenant", icon: <MdGroups className="h-6 w-6" />, component: <UsersPage /> },
  { name: "Team", layout: "/portal", path: "team", access: "partner", icon: <MdGroups className="h-6 w-6" />, component: <PartnerTeamPage /> },
  { name: "Profile", layout: "/portal", path: "profile", icon: <MdPerson className="h-6 w-6" />, component: <ProfilePage /> },
  { name: "Sign In", layout: "/auth", path: "sign-in", icon: <MdLock className="h-6 w-6" />, component: <SignIn /> },
  { name: "Accept Invite", layout: "/auth", path: "accept-invite", icon: <MdLock className="h-6 w-6" />, component: <AcceptInvite /> },
  { name: "Set Password", layout: "/auth", path: "set-password", icon: <MdLock className="h-6 w-6" />, component: <SetPassword /> },
  { name: "Forgot Password", layout: "/auth", path: "forgot-password", icon: <MdLock className="h-6 w-6" />, component: <ForgotPassword /> },
  { name: "Reset Password", layout: "/auth", path: "reset-password", icon: <MdLock className="h-6 w-6" />, component: <ResetPassword /> },
];
export function routeAllowed(route, isPartner) {
  if (route.access === "tenant") return !isPartner;
  if (route.access === "partner") return isPartner;
  return true;
}

export function homePath(isPartner) {
  return isPartner ? "/portal/overview" : "/portal/dashboard";
}

export default routes;
